<template>
  <div class="home-wrap app-content">
    <div class="padding-12-15 padding-b-30">
      <div class="title-text">推广订单</div>
      <div class="search-wrap">
        <div class="form-item">
          <el-col :span="12">
            <el-select v-model="searchForm.order_status" placeholder="全部订单" style="width: 165px;">
              <el-option v-for="item in status_list" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-input v-model="searchForm.orderid" placeholder="订单编号"></el-input>
          </el-col>
        </div>
        <div class="form-item">
          <el-col :span="12">
            <el-select v-model="searchForm.app_key" placeholder="全部推广位" style="width: 165px;">
              <el-option v-for="item in appList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-col>
        </div>
        <div class="form-item">
          <div class="date-picker">
            <el-col :span="11">
              <el-input v-model="searchForm.start_time" @blur.native @focus="showDatePicker('startTime')"
                placeholder="下单日期" suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.start_time" src="../../../../assets/img/login_btn_cancel.png"
                alt="" @click="clear('searchForm.start_time')">
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-input v-model="searchForm.end_time" @blur.native @focus="showDatePicker('endTime')" placeholder="下单日期"
                suffix-icon="el-icon-times" readonly></el-input>
              <img class="clear-icon" v-show="searchForm.end_time" src="../../../../assets/img/login_btn_cancel.png"
                alt="" @click="clear('searchForm.end_time')">
            </el-col>
          </div>
          <van-popup v-model="isPopShow" position="bottom" round>
            <van-datetime-picker v-model="startTime" type="date" :max-date="currentTime" :formatter="formatter"
              :visible-item-count="5" v-if="datePicker == 'startTime'" title='请选择开始时间' @cancel="cancelPicker"
              @confirm="confirmPicker" show-toolbar />
            <van-datetime-picker v-model="endTime" type="date" :min-date="startTime" :max-date="currentTime"
              :formatter="formatter" :visible-item-count="5" v-if="datePicker == 'endTime'" title='请选择结束时间'
              @cancel="cancelPicker" @confirm="confirmPicker" show-toolbar />
          </van-popup>
        </div>
        <div class="search-box">
          <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
            <div><span class="search-btn" @click="handleFilter">查询</span></div>
            <div><span class="download-btn" @click="downReport">下载报表</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15 padding-b-8">
      <div class="title-text">影票订单列表</div>
      <div class="table-wrapper">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error"
            error-text="请求失败，点击重新加载" :immediate-check="false" :offset="200" @load="onLoad">
            <div class="column-box" v-for="(item, index) in list" :key="index">
              <div class="padding-10-15">
                <div>影片名称：<span class="color-222">{{ item.movie_name }}</span></div>
                <div>下单时间：<span class="color-222">{{ item.order_create_time }}</span></div>
                <div>订单编号：<span class="color-222">{{ item.order_id }}</span></div>
                <div>影票数量：<span class="color-222">{{ item.order_num }}</span></div>
                <div>付款金额：<span class="color-222" v-if="item.pay_amount != '无'">{{ item.pay_amount }}元</span></div>
                <div>推广佣金：<span class="color-fe5" v-if="item.app_commission != '无'">{{ item.app_commission }}元</span>
                </div>
                <div>订单状态：<span class="color-ff8">{{ item.order_status_str }}</span></div>
                <div>结算时间：<span>{{ item.settle_time }}</span></div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { getDate } from '@/utils/date'
import { getOrderList, orderExport } from '@/api/order'
import { getToken } from '@/utils/auth'
export default {
  name: 'PromotionOrder',
  data() {
    return {
      status_list: [],
      list: [],
      total: 0,
      appList: [],
      searchForm: {
        page: 1,
        pagesize: 10,
        order_status: '',
        order_id: '',
        app_key: '',
        start_time_bak: '',
        end_time_bak: '',
        start_time: '',
        end_time: '',
        sort: '-id'
      },
      dataShowType: 1,//1加载中 2无数据 3显示数据列表
      //下拉刷新
      isLoading: false,//下拉刷新状态
      //加载更多
      loading: false,
      finished: false,
      error: false,
      isAjaxRequest: false,
      currentTime: new Date(), // 开始时间不能超过当前时间
      startTime: new Date(), // 开始时间
      endTime: new Date(), // 结束时间
      datePicker: '', // 用于判断哪个选择器的显示与隐藏
      isPopShow: false, // 弹出层隐藏与显示
    }
  },
  created() {
    this.getroadList();
  },
  methods: {
    //下拉刷新
    onRefresh() {
      this.searchForm.page = 1;
      //this.data = [];
      this.finished = false;//数据量少刷新时候可能会触发加载更多，先屏蔽掉
      this.getroadList();
    },
    //上拉加载
    onLoad() {
      this.searchForm.page += 1;
      this.getroadList();
    },
    getroadList() {
      //let searchForm = Object.assign({}, this.searchForm)
      if (this.isAjaxRequest) {
        return
      }
      this.isAjaxRequest = true
      let param = {
        page: this.searchForm.page,
        pagesize: this.searchForm.pagesize,
        order_status: this.searchForm.order_status,
        order_id: this.searchForm.order_id,
        app_key: this.searchForm.app_key,
        start_time: this.searchForm.start_time,
        end_time: this.searchForm.end_time,
        sort: '-id'
      }
      getOrderList(param).then((response) => {
        this.listLoading = false
        if (response.code === 200) {
          let res = response.data;
          console.log('res', res)
          //无数据且初始数据为空
          if (!res.list.length && !this.list.length) {
            this.dataShowType = 2;
            this.loading = false;// 加载状态结束
            this.isLoading = false;
            this.finished = true;
            this.isAjaxRequest = false
            return false;
          }
          // 当前分类的数据为空
          if (this.searchForm.page === 1 && !res.list.length) {
            this.dataShowType = 2;
            this.loading = false; // 加载状态结束
            this.isLoading = false;
            this.finished = true;
            this.isAjaxRequest = false
            return false;
          }
          //数据是否全部加载完成
          this.finished = (res.list.length < this.searchForm.pagesize);
          if (this.searchForm.page === 1) {
            if (this.isLoading) {
              this.$toast.success({
                message: '刷新成功',
                duration: 500,
              });
            }
            //刷新
            this.list = res.list;
            this.status_list = res.status_list
            this.appList = res.appList
          } else {
            //加载更多
            this.list = [...this.list, ...res.list];
          }
          this.loading = false;// 加载状态结束
          this.isLoading = false;
          this.dataShowType = 3;
          console.log('page', this.searchForm.page);
        } else {
          this.showType = 2;
          this.upFinished = true;
          this.$toast.fail(response.msg)
          return
        }
        this.isAjaxRequest = false
      }).catch(error => {
        this.$toast.fail(err);
        this.dataShowType = 4;
        this.isAjaxRequest = false
      })
    },
    handleFilter() {
      this.getroadList()
    },
    downReport: function () {
      let searchForm = Object.assign({}, this.searchForm)
      this.$toast.success('正在下载...')
      const aLink = document.createElement('a');
      let exportUrl = process.env.VUE_APP_PROXY_TARGET + 'index/order/orderExport?order_status=' + searchForm.order_status + '&order_id=' + searchForm.order_id + '&start_time=' + searchForm.start_time + '&end_time=' + searchForm.end_time + '&token=' + getToken()
      console.log(exportUrl)
      aLink.href = exportUrl
      aLink.click();
      aLink.remove();
    },
    showDatePicker(picker) { //弹出层并显示时间选择器
      this.isPopShow = true;
      this.datePicker = picker;
    },
    cancelPicker() { // 选择器取消按钮点击事件
      this.isPopShow = false;
      this.datePicker = "";
    },
    confirmPicker(value) {// 确定按钮，时间格式化并显示在页面上
      var date = value;
      var m = date.getMonth() + 1;
      var d = date.getDate();
      if (m >= 1 && m <= 9) {
        m = "0" + m;
      }
      if (d >= 0 && d <= 9) {
        d = "0" + d;
      }
      var timer = date.getFullYear() + "-" + m + "-" + d
      if (this.datePicker == 'startTime') {
        this.searchForm.start_time = timer;
      } else {
        this.searchForm.end_time = timer;
      }
      this.isPopShow = false;
      this.datePicker = "";
    },
    formatter(type, value) {// 格式化选择器日期
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      }
      return value;
    },
    //清除文本框
    clear(val) {
      if (val.indexOf(".") > -1) {
        let varArr = val.split(".")
        this[varArr[0]][varArr[1]] = ''
      } else {
        this[val] = ''
      }
    },
  }
}
</script>

<style lang="less" scoped>
.home-wrap {
  font-family: Alibaba-PuHuiTi-R;

  .search-wrap {
    overflow: hidden;
    color: #666666;

    .form-item {
      padding-top: 8px;
      overflow: hidden;

      .choose-time {
        height: 44px;
        border: 1px solid #E8E8E8;
        vertical-align: middle;
        display: flex;
        align-items: center;
        padding-left: 15px;
        padding-right: 10px;

        .time-input {
          border: none;
          outline: none;
          border-radius: 2px;
        }

        .line {
          text-align: center;
          color: #999999;
        }
      }
    }

    .form-item-tip {
      margin-right: 10px;
    }

    .search-box {
      padding: 30px 35px 0 35px;

      .download-btn {
        display: block;
        width: 130px;
        height: 35px;
        line-height: 35px;
        background: #FFFFFF;
        border-radius: 20px;
        border: 1px solid #FF8622;
        color: #FF8622;
        font-size: 14px;
        cursor: pointer;
        text-align: center;
      }

      .search-btn {
        display: block;
        width: 130px;
        height: 35px;
        line-height: 35px;
        background: #FF8622;
        border-radius: 20px;
        color: #FFFFFF;
        font-size: 14px;
        cursor: pointer;
        text-align: center;
      }
    }
  }

  .table-wrapper {
    margin-top: 8px;

    .column-box {
      background: #FAFAFA;
      border-radius: 4px;
      height: auto;
      margin-bottom: 10px;
      color: #999999;
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/order/Index.vue